/**
 * Prevent drop event.
 *
 * @param {object} event Event.
 */
function dropPrevent(event) {
  if (event.type === 'drop') {
    if (event.stopPropagation) {
      event.preventDefault();
      event.stopPropagation();
    }

    return false; // (IE)
  }
}

function addEvent(element) {
  if (element.addEventListener) {
    element.addEventListener('drop', dropPrevent, true);
  } else if (element.attachEvent) {
    element.attachEvent('ondrop', dropPrevent);
  }
}

function removeEvent(element) {
  if (element.removeEventListener) {
    element.removeEventListener('drop', dropPrevent, true);
  } else if (element.DetachEvent) {
    element.DetachEvent('ondrop', dropPrevent);
  }
}

/**
 * Prevent drop event.
 */
export function preventDrop() {
  addEvent(document);
}

/**
 * Remove code of drop event prevention.
 */
export function allowDrop() {
  removeEvent(document);
}
